export default __webpack_public_path__ + "assets/images/m-form-bg-6b197deb.png";